<template>
  <Tweet
    tweet_link="https://x.com/SonicLabs/status/1933510173454180728"
    image_name="sonic.jpg"
    name="Sonic"
    handle="@SonicLabs"
    is_verified
    is_gold
  >
    Unlock the full story of Sonic tokens with
    <b>@bubblemaps</b>&nbsp;V2.<br /><br />
    🔍 Time Travel<br />
    Rewind any token’s history. Every holder and shift since launch.<br />
    🔮 Magic Nodes<br />
    Reveal hidden links between wallets. Uncover the clusters others miss.<br />
  </Tweet>
</template>

<script>
import Tweet from "@/components/atoms/Tweet.vue";

export default {
  components: {
    Tweet,
  },
};
</script>
